import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@chatterbug/aaron'

import { t } from 'src/lib/i18n-react'

const INDICATOR_COLOR = 'yellow65'

const SHAPE_STYLES = {
  borderRadius: '1x',
  px: '1x',
  height: '24px',
  display: 'flex',
  alignItems: 'center',
  backgroundColor: INDICATOR_COLOR,
}

export const INDICATOR_BORDER_STYLES = {
  borderTopWidth: '4px',
  borderTopStyle: 'solid',
  borderTopColor: INDICATOR_COLOR,
}

export const INDICATOR_SHAPE_POSITION_STYLES = {
  position: 'absolute',
  top: '-10px',
  transform: 'translate(50%)',
  zIndex: 1,
}

export const INDICATOR_SHAPE_POSITION_STYLES_ABOVE_ALL = {
  ...INDICATOR_SHAPE_POSITION_STYLES,
  zIndex: 1000,
}

const CurrentUnitIndicator = ({ sx }) => {
  return (
    <Box
      variant="text.tinyTitle"
      right={{ _: '50%', tablet: '15%', laptop: '10%' }}
      sx={{
        ...SHAPE_STYLES,
        ...sx,
      }}
    >
      {t('Currently learning')}
    </Box>
  )
}

CurrentUnitIndicator.propTypes = {
  sx: PropTypes.object,
}

export default CurrentUnitIndicator
